import { yupResolver } from '@hookform/resolvers/yup';
import { IAcquirerRiskManagementParameterFormMeta } from '@Modules/admin/integrationSettings/containers/forms/base/acquirerRiskManagementParameters/acquirerRMPMeta';
import { CustomButton, CustomInputCheckBox } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import { useForm } from 'react-hook-form';
import CustomFormBankIDInput from '../../CustomFormBankIDInput';
import CustomFormCorporateNameTextInput from '../../CustomFormCorpoNameTextInput';

type Props = {
  meta: IAcquirerRiskManagementParameterFormMeta,
} & TFormUIProps;

const AcquirerRiskManagementParametersFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <>
      <CC.Heading size="md" mb={'2rem'}>
        Acquirer Risk Management Parameters
      </CC.Heading>
      <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
        <CC.Stack spacing="4" direction={['column', 'column', 'row']}>
          <CustomFormBankIDInput
            isLoading={isLoading}
            register={register(meta.bankID.name)}
            hasError={errors[meta.bankID.name]}
          />

          <CustomFormCorporateNameTextInput
            isLoading={isLoading}
            register={register(meta.corporateName.name)}
            hasError={errors[meta.corporateName.name]}
          />
        </CC.Stack>

        <CC.Box mt={'2rem'}>
          <CC.Stack
            justifyContent={'space-between'}
            direction={['column', 'column', 'row']}
          >
            <CustomFormControl
              w={'auto'}
              isLoading={isLoading}
              isInvalid={!!errors[meta.paymentScheme.name]}
            >
              <CustomInputCheckBox
                meta={meta.paymentScheme}
                register={register(meta.paymentScheme.name)}
                hasError={errors[meta.paymentScheme.name]}
              >
                {meta.paymentScheme.label}
              </CustomInputCheckBox>
            </CustomFormControl>

            <CustomFormControl
              w={'auto'}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardType.name]}
            >
              <CustomInputCheckBox
                meta={meta.cardType}
                register={register(meta.cardType.name)}
                hasError={errors[meta.cardType.name]}
              >
                {meta.cardType.label}
              </CustomInputCheckBox>
            </CustomFormControl>

            <CustomFormControl
              w={'auto'}
              isLoading={isLoading}
              isInvalid={!!errors[meta.cardTypeNetwork.name]}
            >
              <CustomInputCheckBox
                meta={meta.cardTypeNetwork}
                register={register(meta.cardTypeNetwork.name)}
                hasError={errors[meta.cardTypeNetwork.name]}
              >
                {meta.cardTypeNetwork.label}
              </CustomInputCheckBox>
            </CustomFormControl>

            <CustomFormControl
              w={'auto'}
              isLoading={isLoading}
              isInvalid={!!errors[meta.paymentChannel.name]}
            >
              <CustomInputCheckBox
                meta={meta.paymentChannel}
                register={register(meta.paymentChannel.name)}
                hasError={errors[meta.paymentChannel.name]}
              >
                {meta.paymentChannel.label}
              </CustomInputCheckBox>
            </CustomFormControl>

            <CustomFormControl
              w={'auto'}
              isLoading={isLoading}
              isInvalid={!!errors[meta.solvabilityLevel.name]}
            >
              <CustomInputCheckBox
                meta={meta.solvabilityLevel}
                register={register(meta.solvabilityLevel.name)}
                hasError={errors[meta.solvabilityLevel.name]}
              >
                {meta.solvabilityLevel.label}
              </CustomInputCheckBox>
            </CustomFormControl>
          </CC.Stack>
        </CC.Box>

        <CC.HStack my={6} justifyContent={'flex-end'}>
          <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
        </CC.HStack>
      </CC.Box>
    </>
  );
};

export default AcquirerRiskManagementParametersFormUI;
